import React, { useMemo } from 'react';
import { AudioTranscriptionContext } from '../hooks/useAudioTranscription.js';
import { FileAttachmentsContext } from '../hooks/useFileAttachments.js';

const ChatProviders = ({ audioTranscription, fileAttachments, children }) => {
    const memoizedAudio = useMemo(() => audioTranscription, [audioTranscription]);
    const memoizedFile = useMemo(() => fileAttachments, [fileAttachments]);

    return (
        <AudioTranscriptionContext.Provider value={memoizedAudio}>
            <FileAttachmentsContext.Provider value={memoizedFile}>
                {children}
            </FileAttachmentsContext.Provider>
        </AudioTranscriptionContext.Provider>
    );
};

export default React.memo(ChatProviders);